import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, Controller } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Znajdź wszystkie kontenery sliderów na stronie
    const sliderContainers = document.querySelectorAll('.products-slider-tabs');

    // Jeśli nie ma żadnego kontenera, zakończ
    if (sliderContainers.length === 0) return;

    // Dla każdego kontenera inicjalizuj slajdery i obsługę zakładek
    sliderContainers.forEach((container) => {
        // Pobierz unikalny identyfikator kontenera
        const containerId = container.getAttribute('data-slider-container');

        // Znajdujemy wszystkie slidery w tym kontenerze
        const sliders = container.querySelectorAll('.products-slider-tabs__slider');

        // Znajdujemy przyciski nawigacyjne dla tego kontenera
        const navPrevButton = container.querySelector('.products-slider-tabs__button-prev');
        const navNextButton = container.querySelector('.products-slider-tabs__button-next');

        // Tablica przechowująca instancje Swipera
        const swiperInstances = {};

        // Aktywna instancja Swipera
        let activeSwiper = null;

        // Inicjalizujemy każdy slider
        sliders.forEach((slider) => {
            const sliderId = slider.getAttribute('data-slider-id');

            // Inicjalizacja Swipera dla tego kontenera
            swiperInstances[sliderId] = new Swiper(slider, {
                // Załaduj moduły
                modules: [Pagination, Navigation, Autoplay, Controller],

                // Podstawowe ustawienia
                slidesPerView: 2.3,  // Domyślnie pokazuje 1 slajd
                spaceBetween: 15,  // Odstęp między slajdami

                // Autoplay (opcjonalnie)
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },

                // Ustawienia responsywne zgodnie z wymaganiami
                breakpoints: {
                    // >= 768px
                    768: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    // >= 968px
                    968: {
                        slidesPerView: 2.5,
                        spaceBetween: 30,
                    },
                    // >= 1024px
                    1024: {
                        slidesPerView: 2.8,
                        spaceBetween: 30,
                    },
                    // >= 1200px
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    // >= 1300px
                    1300: {
                        slidesPerView: 3.33,
                        spaceBetween: 30,
                    },
                    1600: {
                        slidesPerView: 4.33,
                        spaceBetween: 30,
                    },
                    1900: {
                        slidesPerView: 5.33,
                        spaceBetween: 30,
                    },
                }
            });
        });

        // Obsługa przełączania między zakładkami
        const tabButtons = container.querySelectorAll('.products-slider-tabs__tab-button');
        const tabContents = container.querySelectorAll('.products-slider-tabs__tab-content');

        // Ustawiamy globalną obsługę przycisków nawigacyjnych
        if (navPrevButton && navNextButton) {
            // Obsługa przycisku "Poprzedni"
            navPrevButton.addEventListener('click', function(e) {
                e.preventDefault();
                if (activeSwiper) {
                    activeSwiper.slidePrev();
                }
            });

            // Obsługa przycisku "Następny"
            navNextButton.addEventListener('click', function(e) {
                e.preventDefault();
                if (activeSwiper) {
                    activeSwiper.slideNext();
                }
            });
        }

        // Obsługa kliknięcia w tab
        tabButtons.forEach(button => {
            button.addEventListener('click', function() {
                const tabId = this.getAttribute('data-tab-id');

                // Usuń klasę active ze wszystkich przycisków i zawartości zakładek
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(content => content.classList.remove('active'));

                // Dodaj klasę active do klikniętego przycisku i odpowiedniej zakładki
                this.classList.add('active');
                const activeContent = container.querySelector(`#${tabId}`);
                if (activeContent) {
                    activeContent.classList.add('active');

                    // Aktualizujemy aktywny Swiper i odświeżamy go
                    activeSwiper = swiperInstances[tabId];
                    if (activeSwiper) {
                        activeSwiper.update();
                    }
                }
            });
        });

        // Upewnij się, że pierwsza zakładka jest aktywna
        if (tabButtons.length > 0 && tabContents.length > 0) {
            tabButtons[0].classList.add('active');
            tabContents[0].classList.add('active');
 
            // Pobierz ID pierwszego slidera i ustaw go jako aktywny
            if (tabButtons[0]) {
                const firstTabId = tabButtons[0].getAttribute('data-tab-id');
                activeSwiper = swiperInstances[firstTabId];
                if (activeSwiper) {
                    activeSwiper.update();
                }
            }
        }
    });
});